import React from 'react'

function TenderTextINN6() {
  return (
    <embed src="\pdfs\EAT1.1.8_IN-N_Induction_outlet_with_preset_discharge_direction_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextINN6